import { TextTooltip } from '../text-tooltip';
import useLocale from '@/client/hooks/use-locale';
import { formatAfterDate, formatDate } from '@/client/utils/format';
import type { Time } from 'lightweight-charts';

type FormatDateProps = {
  time?: Time | Date | null;
};
export const FormatAfterDate = ({ time }: FormatDateProps) => {
  const { locale } = useLocale();
  
  // Handle undefined/null time
  if (!time) {
    return <span>-</span>;
  }
  
  try {
    return (
      <TextTooltip tooltip={formatDate(time, locale, 'PPp')} show={true}>
        {formatAfterDate(time, locale)}
      </TextTooltip>
    );
  } catch {
    // Handle invalid time value gracefully
    return <span>-</span>;
  }
};
